import { HugeiconsIcon } from "@hugeicons/react";
import { Alert02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

const bannerTitle = (
  count: number,
  { unit, units }: { unit: string; units: string }
) =>
  count === 1
    ? `1 listed ${unit} needs a lockbox or entry instructions`
    : `${count} listed ${units} need a lockbox or entry instructions`;

export const NeedsLockboxBanner = ({
  count,
  isFiltered,
  onToggle
}: {
  count: number;
  isFiltered: boolean;
  onToggle: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();

  return (
    <div
      role="status"
      className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-warning-100 bg-warning-50 px-4 py-3 md:flex-nowrap"
    >
      <HugeiconsIcon
        icon={Alert02Icon}
        size={20}
        className="shrink-0 text-warning-600"
      />
      <div className="min-w-0 flex-1 text-sm text-warning-800">
        <p className="m-0 font-bold">{bannerTitle(count, dictionary)}</p>
        <p className="m-0">
          These {dictionary.units} use self-guided showings, but leads who book
          a tour won&apos;t receive an access code.
        </p>
      </div>
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        className="shrink-0 !border-warning-100 !text-warning-800"
        onClick={onToggle}
      >
        {isFiltered
          ? `Show all ${dictionary.units}`
          : `View ${dictionary.units}`}
      </Button>
    </div>
  );
};
